import { render, staticRenderFns } from "./PostSidebar.component.vue?vue&type=template&id=216df7d6&"
import script from "./PostSidebar.component.vue?vue&type=script&lang=js&"
export * from "./PostSidebar.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports